import * as React from 'react';
import * as _ from 'lodash';
import {RowDataType, TableState} from '../redux/actions';
import {TableContext} from '../redux/createTableContext';
import withTable from '../redux/withTable';
import BulkEditDialog from './BulkEditDialog';
import BulkEditIcon from 'mdi-material-ui/PlaylistEdit';
import {findDOMNode} from 'react-dom';
import Button, {ButtonProps} from '@material-ui/core/Button';
import connectWithRouter from '../../../shared/components/redux/connectWithRouter';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';

export type TableContextProps = 'onChange';
export type TableStateProps = 'selection' | 'columns' | 'data' | 'filter';
type BulkEditButtonProps<RowData extends RowDataType> = Pick<TableContext, TableContextProps> &
  Pick<TableState<RowData>, TableStateProps> &
  ButtonProps;

@connectWithRouter(() => {}, {addDynamicDialog})
class BulkEditButton<RowData extends RowDataType> extends React.PureComponent<
  BulkEditButtonProps<RowData> & {addDynamicDialog?: typeof addDynamicDialog}
> {
  private handleColumnChooserOpen = () => {
    const {columns, onChange, data, selection, filter, addDynamicDialog} = this.props;
    addDynamicDialog(BulkEditDialog, {
      anchorEl: findDOMNode(this) as HTMLElement,
      columns: _.omitBy(columns, column => column.readOnly),
      onChange: onChange as any,
      data: data,
      selection: selection,
      filter: filter,
    });
  };

  render() {
    return (
      <Button id="cla-btn-bulk-edit" onClick={this.handleColumnChooserOpen}>
        <BulkEditIcon />
        Bulk edit
      </Button>
    );
  }
}
export default withTable<TableContextProps | TableStateProps>({
  props: ['onChange', 'columns', 'data', 'selection', 'filter'],
})(BulkEditButton);
